import { formatISO, isFuture } from 'date-fns'
import { boolean, object, string } from 'yup'

const DiscretionaryCommissionSchema = object().shape({
  full_name: string()
    .required('Full name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,255}$/,
      'Full name can only contain letters and basic punctuation',
    )
    .min(2, 'Full name must be at least 2 characters')
    .max(255, 'Full name must be at most 255 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  dob: string()
    .required('Please enter your date of birth')
    .transform((value) => {
      if (value) {
        const parts = value.split('/')
        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0])
        return formatISO(formattedDate, { representation: 'date' })
      }
      return value
    })
    .test(
      'is-future',
      'Date of birth cannot be in the future',
      (value) => !isFuture(value),
    ),
  address_line1: string().required('Address Line 1 is required').trim(),
  address_line2: string().trim(),
  town: string().required('Town is required').trim(),
  county: string().trim(),
  postcode: string()
    .required('Postcode is required')
    .trim()
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    ),
  same_address: boolean().required(),
  prev_address_line1: string().when('same_address', {
    is: (value) => [false].includes(value),
    then: (rule) => rule.trim().required('Previous Address Line 1 is required'),
  }),
  prev_address_line2: string().trim(),
  prev_town: string().when('same_address', {
    is: (value) => [false].includes(value),
    then: (rule) => rule.trim().required('Previous Town is required'),
  }),
  prev_county: string().trim(),
  prev_postcode: string().when('same_address', {
    is: (value) => [false].includes(value),
    then: (rule) =>
      rule
        .required('Previous Postcode is required')
        .trim()
        .matches(
          /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
          'Postcode must be a valid UK postcode',
        ),
  }),
  reg_num: string().trim(),
  vehicle: string().trim(),
  bought: string()
    .transform((value) => {
      if (value) {
        const parts = value.split('/')
        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0])
        return formatISO(formattedDate, { representation: 'date' })
      }
      return value
    })
    .test(
      'is-future',
      'Date of birth cannot be in the future',
      (value) => !isFuture(value),
    ),
  agreement_or_reg_num: string().trim(),
  dealer: string().trim(),
  accept: boolean().oneOf(
    [true],
    'Please confirm you have read, understood and give consent to be emailed',
  ),
})

export default DiscretionaryCommissionSchema
